import { useState } from 'react'
import {
    CountryDropdownList,
    FastQuoteInput,
    DropdownList,
    InternationalPhoneInput,
    StateDropdownList,
    AWCButton,
    BUTTON_TYPES,
} from '../../GlobalComponents/Inputs/Inputs'
import styles from './CreatePreSaleAccount.module.scss'
import 'react-phone-input-2/lib/style.css'
import './CreatePreSaleAccount.css'
import { AutocompleteAddressInput } from './ShippingModal'
import { useAppDispatch } from '../../app/hooks'
import {
    AddCustomerPayload,
    AddShipToPayload,
    fetchGetContact,
    PostSaveContactPayload,
    fetchCustomerExists,
    UpdatePricingTiersPayload,
} from '../../features/customer/customerAPI'
import {
    validAddCustomerPayload,
    postAddCustomer,
    postAddContact,
    postAddShipTo,
    validAddContactPayload,
    AddContactPayload,
    validShipToPayload,
    postSaveContact,
    PACustomerContactViewRow,
} from '../../features/customer/customerSlice'
import { startQuote } from '../../features/order/orderSlice'
import { fetchUpdatePricingTiers } from '../../features/customer/customerAPI'
import React from 'react'
import { MenuItem } from '@material-ui/core'
import { CUSTOMER_REASONS, CUSTOMER_TYPES, COUNTRY_TABLE } from '../../consts'
import { getCookie } from '../../GlobalComponents/GlobalFunctions'
import { fqAlert, fqConfirm } from '../../GlobalComponents/NotificationManager/NotificationManager'
import _ from 'lodash'
import { formatPhoneNumber } from '../../utils'
import { logEvent } from '../../GlobalComponents/GlobalFunctions'
import { validEmail, validPhone } from '../../GlobalComponents/Validator'

interface CreatePreSaleAccountProps {
    back(): void
    email?: string
}

// interface PricingTiersTableProps {
//     selectedTier: number
//     setSelectedTier: Dispatch<SetStateAction<number>>
// }

export const validUSZip = (val: string) => {
    return /(^\d{5}$)|(^\d{5}-\d{4}$)/.test(val)
}
// const PricingTiersTable = (props: PricingTiersTableProps) => {
//     const { selectedTier, setSelectedTier } = props
//     const pricingTiers = useAppSelector((state) => state.customer.pricingTiers || [])
//     const handlePricingTierChange = React.useCallback(
//         (e: React.ChangeEvent<HTMLInputElement>) => {
//             setSelectedTier(parseInt(e.target.value))
//         },
//         [setSelectedTier]
//     )
//     return (
//         <div className={styles.pricingTierContainer}>
//             <div className={styles.pricingTierHeader}>
//                 <div>Active</div>
//                 <div>Pricing Tier</div>
//             </div>
//             <Scrollbars
//                 // style={{ height: '100'}}
//                 className={'scroll-bar'}
//                 renderTrackHorizontal={() => <div />}
//                 autoHeight
//                 autoHeightMin={200}
//                 autoHeightMax={300}
//             >
//                 {pricingTiers.map((tier) => {
//                     return (
//                         <div className={styles.pricingTierRow} key={tier.CustomerContractKey}>
//                             <div>
//                                 <StyledRadioSingleChoice
//                                     checked={tier.CustomerContractKey === selectedTier}
//                                     value={tier.CustomerContractKey}
//                                     style={!!selectedTier ? { color: 'var(--linkblue)' } : {}}
//                                     onChange={handlePricingTierChange}
//                                 />
//                             </div>
//                             <span style={{ alignSelf: 'center' }}>{tier.ContractNumber}</span>
//                         </div>
//                     )
//                 })}
//             </Scrollbars>
//         </div>
//     )
// }

const CreatePreSaleAccount = (props: CreatePreSaleAccountProps) => {
    const [selectedTier] = useState<number>(0)
    const [failedToAdd, setFailedToAdd] = useState(false)
    const dispatch = useAppDispatch()

    const { back, email = '' } = props

    const defaultShipping = {
        state: '',
        address1: '',
        address2: '',
        zipcode: '',
        city: '',
        country: 'US',
        name: '',
    }

    const def = {
        email: email,
        firstName: '',
        lastName: '',
        phone: '',
        title: '',
        accountCode: '',
        companyName: '',
        identifier: CUSTOMER_REASONS.STANDARD.reasonId.toString(),
        type: CUSTOMER_TYPES.UNCERTAIN.typeId.toString(),
        projectName: '',
    }

    const [fields, setFields] = useState({
        ...def,
        contactAddress: { ...defaultShipping },
        shipToAddress: { ...defaultShipping },
        billToAddress: { ...defaultShipping },
    })
    const emailRef = React.useRef<null | string>(null)
    const emailSearchedRef = React.useRef('')
    const [phoneExtension, SetPhoneExtension] = useState('')
    const [hasContactAddress2, setHasContactAddress2] = useState(false)
    const [hasShipToAddress2, setHasShipToAddress2] = useState(false)
    const [hasBillToAddress2, setHasBillToAddress2] = useState(false)
    const [loadedContact, setLoadedContact] = useState<ContactViewRow | null>(null)
    const debouncedLoadContact = React.useCallback(
        _.debounce(
            async (email: string) => {
                emailSearchedRef.current = email
                let contact2 = await fetchGetContact(email)
                // null on first load
                if (contact2 && (emailRef.current === null || emailRef.current === email)) {
                    // for some reason typescript doesnt type contact right without contact2 here
                    let contact = contact2
                    let extension = ''
                    let phone = ''
                    if (contact.TelephoneNumber) {
                        let rawNumber = contact.TelephoneNumber.trim()
                        let isUSNumber = false
                        // if there's no plus it's US so we're adding 1
                        if (!rawNumber.startsWith('+')) {
                            rawNumber = '1' + rawNumber
                            isUSNumber = true
                        }
                        // because of numbers like (713) 748-6100 473 we'll just use the first 10 num as the number if we know it's US
                        if (isUSNumber) {
                            rawNumber = rawNumber.replace(/[^0-9]/g, '')

                            phone = rawNumber.substr(0, 11)
                            extension = rawNumber.substr(11)
                        } else {
                            // git rid of anything not a number or x and slap prex in phone number and rest in extension
                            rawNumber = rawNumber.replace(/[^x0-9]/g, '')
                            let parts = contact.TelephoneNumber.split('x')
                            phone = parts[0]
                            extension = parts[1] || ''
                        }
                    }
                    if (phone === '') {
                        phone = '1'
                    }
                    setFields((oldFields) => ({
                        ...oldFields,
                        firstName: contact.FirstName?.trim() || '',
                        lastName: contact.LastName?.trim() || '',
                        phone: phone,
                        contactAddress: {
                            country: contact.Country?.trim() || '',
                            city: contact.City?.trim() || '',
                            state: contact.State?.trim() || '',
                            zipcode: contact.Zipcode?.trim() || '',
                            name: contact.CompanyName?.trim() || '',
                            address1: contact.Address1?.trim() || '',
                            address2: contact.Address2?.trim() || '',
                        },
                    }))
                    SetPhoneExtension(extension)
                    setLoadedContact(contact)
                    fqAlert({ type: 'success', message: 'Existing contact loaded' })
                }
            },
            200,
            { trailing: true }
        ),
        []
    )

    React.useEffect(() => {
        if (fields.email && fields.email !== emailSearchedRef.current) {
            debouncedLoadContact(fields.email)
        }
    }, [fields])
    const copyContactToShipTo = () => {
        setFields((fields) => ({
            ...fields,
            shipToAddress: { ...fields.contactAddress, name: fields.companyName },
        }))
    }

    const copyContactToBillTo = () => {
        setFields((fields) => ({
            ...fields,
            billToAddress: { ...fields.contactAddress, name: fields.companyName },
        }))
    }

    const makeCustomerPayload = (): AddCustomerPayload => {
        let billToFields = {
            BillToName: fields.billToAddress.name,
            BillToAddress1: fields.billToAddress.address1,
            BillToAddress2: fields.billToAddress.address2,
            BillToZipcode: fields.billToAddress.zipcode,
            BillToCity: fields.billToAddress.city,
            BillToState: fields.billToAddress.state,
            BillToCountry: fields.billToAddress.country,
            BillToCountryName: COUNTRY_TABLE.find(
                (row) => row.Code === fields.billToAddress.country
            )?.Name, //use the name because that's what we get when we load an order
        }

        let billToAddress = fields.billToAddress
        let newCustomer: AddCustomerPayload['Customer'][number] = {
            AccountCode: fields.accountCode,
            BillToName: billToAddress.name || fields.companyName,
            BillToAddress1: '',
            BillToAddress2: '',
            BillToZipcode: '',
            BillToCity: '',
            BillToState: '',
            BillToCountry: '',
            ContactName: `${fields.firstName} ${fields.lastName}`,
            ContactEmail: fields.email,
            ContactPhone: formatPhoneNumber(fields.phone, phoneExtension),
            Prospect: true,
            FirstTransaction: new Date(),
            CustomerReasonId: fields.identifier,
            CustomerType: fields.type,
            CustomerReasonQualifier:
                fields.identifier === CUSTOMER_REASONS.OTHER.reasonId.toString()
                    ? fields.projectName
                    : '',
            // Defaults to match .net
            AvailabilityMode: 'B',
            CarrierTermsKey: 4,
            InvoiceDocumentTemplate: 'InvoiceCR',
            NamedCarrierServiceKey: '2;7',
            QuoteAttachmentFormats: 'EP',
            LastUpdated: new Date(),
            LastUpdatedBy: getCookie('AWCUsername'),
        }
        // if bill to fields filled in at all
        if (
            Object.entries(billToFields).some((row) => {
                let [key, value] = row
                if (key !== 'BillToCountry') {
                    if (key === 'BillToCountryName') {
                        return false
                    }
                    return value?.trim()
                } else {
                    return value !== 'US'
                }
            })
        ) {
            newCustomer = { ...newCustomer, ...billToFields }
        }

        let payload: AddCustomerPayload = {
            Customer: [newCustomer],
        }
        return payload
    }
    const makeShipToPayload = (): AddShipToPayload => {
        let shipToAddress = fields.shipToAddress

        let payload: AddShipToPayload = {
            accountCode: fields.accountCode,
            isDefault: true,
            ...shipToAddress,
            state: shipToAddress.state.padEnd(5),
            country: shipToAddress.country.padEnd(3),
        }
        return payload
    }

    const makeContactPayload = (): AddContactPayload => {
        let payload: AddContactPayload = {
            accountCode: fields.accountCode,
            firstName: fields.firstName,
            lastName: fields.lastName,
            email: fields.email,
            phone: formatPhoneNumber(fields.phone, phoneExtension),
            title: fields.title,
        }
        return payload
    }

    const makePricingTierPayload = (): UpdatePricingTiersPayload => {
        let payload: UpdatePricingTiersPayload = {
            AccountCode: fields.accountCode,
            ContractKeys: selectedTier === 0 ? [] : [selectedTier],
        }
        return payload
    }

    const saveCustomer = async () => {
        let e = ''

        let customerPayload = makeCustomerPayload()
        let shipToPayload = makeShipToPayload()
        let noShipToAdded = false
        let contactPayload = makeContactPayload()
        let pricingTierPayload = makePricingTierPayload()
        let addressFields: Array<keyof AddShipToPayload> = [
            'state',
            'name',
            'country',
            'address1',
            'address2',
            'zipcode',
        ]
        let cont = true
        if (
            !validShipToPayload(shipToPayload) &&
            fields.accountCode &&
            addressFields.some((field) => {
                let value = shipToPayload[field]
                if (field === 'country' && typeof value === 'string' && value.trim() === 'US') {
                    return false
                }
                return typeof value === 'string' && value.trim()
            })
        )
            cont = await fqConfirm({
                title: 'Confirm',
                message:
                    'All fields must be entered on a shipping address to add it. Do you want to continue without adding a ship to?',
            })
        if (!cont) return
        if (validAddCustomerPayload(customerPayload) && validAddContactPayload(contactPayload)) {
            if (!validEmail(fields.email)) {
                e += 'You must enter a valid email\n'
            }
            if (fields.phone && !validPhone(fields.phone)) {
                e += 'You must enter a valid phone number'
            }
            if (
                fields.identifier === CUSTOMER_REASONS.OTHER.reasonId.toString() &&
                !fields.projectName
            ) {
                e += 'You must enter a project name if the identifier is "Other"'
            }
            if (e.length > 0) {
                fqAlert({ type: 'error', title: 'There are invalid fields.', message: e })
                return
            }

            try {
                let existingCustomer = await fetchCustomerExists(
                    customerPayload.Customer[0].AccountCode
                )
                if (existingCustomer) {
                    fqAlert({ type: 'error', title: 'Account Code already exists', message: '' })
                    return
                }
                // add customer await so error will
                let res = await dispatch(postAddCustomer(customerPayload))
                // check if resulting action was a rejected action
                if (postAddCustomer.rejected.match(res)) {
                    throw Error('Failed to add customer')
                }
                logEvent({
                    eventName: 'Address Added From FastQuote',
                    string2: 'Pre-Sale Account Setup - Bill To',
                    string3: customerPayload.Customer[0].AccountCode,
                    messageBody: JSON.stringify(customerPayload.Customer[0]),
                })

                //if valid add shipto default
                if (validShipToPayload(shipToPayload)) {
                    dispatch(postAddShipTo(shipToPayload))
                    logEvent({
                        eventName: 'Address Added From FastQuote',
                        string2: 'Pre-Sale Account Setup - Ship To',
                        string3: shipToPayload.accountCode,
                        messageBody: JSON.stringify(shipToPayload),
                    })
                } else {
                    // if we don't have a valid shipto, post a blank one -- needed because
                    // .net search links to shiptos

                    noShipToAdded = true
                }
                // add contact
                let existingContact = await fetchGetContact(contactPayload.email)
                let toContactKey = -1
                if (existingContact) {
                    // update contact Info
                    if (!existingContact.Title) existingContact.Title = contactPayload.title
                    if (!existingContact.TelephoneNumber)
                        existingContact.TelephoneNumber = contactPayload.phone
                    if (!existingContact.FirstName)
                        existingContact.FirstName = contactPayload.firstName
                    if (!existingContact.LastName)
                        existingContact.LastName = contactPayload.lastName
                    toContactKey = existingContact.ContactKey!
                    let newCCACVRow: ContactCustomerAccountCodeRow = {
                        ContactKey: existingContact.ContactKey!,
                        CustomerAccountCode: fields.accountCode,
                        IsInactive: false,
                    }
                    let postSavePayload: PostSaveContactPayload = {
                        Contact: [
                            {
                                ...existingContact,
                                ContactCustomerAccountCodeView: [
                                    ...(existingContact.ContactCustomerAccountCodeView || []),
                                    newCCACVRow,
                                ],
                            },
                        ],
                    }
                    dispatch(postSaveContact(postSavePayload))
                } else {
                    let resp = await dispatch(postAddContact(contactPayload))
                    toContactKey = resp.payload

                    logEvent({
                        eventName: 'Address Added From FastQuote',
                        string2: 'Pre-Sale Account Setup - Contact Address',
                        string3: contactPayload.accountCode,
                        decimal1: toContactKey,
                        messageBody: JSON.stringify(contactPayload),
                    })
                }
                fetchUpdatePricingTiers(pricingTierPayload)
                let accountRow: PACustomerContactViewRow = {
                    AccountCode: customerPayload.Customer[0].AccountCode.trim(),
                    EmailAddress: '',
                    ExactMatch: true,
                    Terms: '',
                    ShipToName: noShipToAdded ? '' : shipToPayload.name,
                    BillToName: customerPayload.Customer[0].BillToName,
                    BillToAddress1: customerPayload.Customer[0].BillToAddress1,
                    BillToAddress2: customerPayload.Customer[0].BillToAddress2,
                    BillToZipcode: customerPayload.Customer[0].BillToZipcode,
                    BillToCity: customerPayload.Customer[0].BillToCity,
                    BillToState: customerPayload.Customer[0].BillToState,
                    BillToCountry: customerPayload.Customer[0].BillToCountry,
                    BillToCountryName: COUNTRY_TABLE.find(
                        (row) => row.Code === fields.billToAddress.country
                    )?.Name, //use the name because that's what we get when we load an order
                    CustomerTypeName: Object.entries(CUSTOMER_TYPES).find(
                        (row) => row[1].typeId === +fields.type
                    )?.[1].typeText,
                }

                let shipToRow: CustomerShipToViewRow = {
                    AccountCode: customerPayload.Customer[0].AccountCode,
                    AvailabilityMode: '',
                    QuoteAttachmentFormats: '',
                    ShipToID: -1,
                    ShipToAddress1: shipToPayload.address1,
                    ShipToAddress2: shipToPayload.address2,
                    ShipToCity: shipToPayload.city,
                    ShipToCountry: shipToPayload.country,
                    ShipToState: shipToPayload.state,
                    ShipToZipcode: shipToPayload.zipcode,
                    ShipToName: shipToPayload.name,
                }
                let contact: ContactCustomerAccountCodeViewRow
                if (existingContact)
                    contact = {
                        FirstName: existingContact.FirstName!,
                        LastName: existingContact.LastName!,
                        EmailAddress: existingContact.EmailAddress,
                        ContactCompanyName: existingContact.CompanyName!,
                        ContactKey: toContactKey,
                        CustomerAccountCode: contactPayload.accountCode,
                        Prospect: true,
                    }
                else {
                    contact = {
                        FirstName: contactPayload.firstName,
                        LastName: contactPayload.lastName,
                        EmailAddress: contactPayload.email,
                        ContactCompanyName: '',
                        ContactKey: toContactKey,
                        CustomerAccountCode: contactPayload.accountCode,
                        Prospect: true,
                    }
                }
                dispatch(
                    startQuote({
                        account: accountRow,
                        shipTo: noShipToAdded ? undefined : shipToRow,
                        contact: contact,
                    })
                )
                props.back()
                // start quote
            } catch (e: any) {
                fqAlert({ type: 'error', title: 'Customer creation failed.', message: e.message })
            }
        } else {
            fqAlert({ type: 'warning', message: 'You must fill in required fields' })
            window.scrollTo(0, 0)
            setFailedToAdd(true)
        }
    }
    function handleEmailBlur(e: any) {
        setEmailFieldActive(false)
    }
    function handlePhoneNumberBlur(e: any) {
        setPhoneFieldActive(false)
    }
    function handleContactZipBlur(e: any) {
        setContactZipFieldActive(false)
    }
    function handleBillToZipBlur(e: any) {
        setBillToZipFieldActive(false)
    }
    function handleShipToZipBlur(e: any) {
        setShipToZipFieldActive(false)
    }
    const [emailFieldActive, setEmailFieldActive] = React.useState<boolean>(false)
    const [phoneFieldActive, setPhoneFieldActive] = React.useState<boolean>(false)
    const [contactZipFieldActive, setContactZipFieldActive] = React.useState<boolean>(false)
    const [billToZipFieldActive, setBillToZipFieldActive] = React.useState<boolean>(false)
    const [shipToZipFieldActive, setShipToZipFieldActive] = React.useState<boolean>(false)
    const [customerAlreadyExists, setCustomerAlreadyExists] = useState({
        exists: false,
        search: '',
    })
    const debouncedCheckIfExists = React.useCallback(
        _.debounce(
            async (value) => {
                let existingCustomer = await fetchCustomerExists(value)
                setCustomerAlreadyExists({
                    exists: existingCustomer,
                    search: value,
                })
            },
            200,
            { trailing: true }
        ),
        []
    )
    const usingLoadedContact =
        loadedContact && loadedContact.EmailAddress?.trim() === fields.email.trim()
    return (
        <div className={styles.container} style={{ position: 'relative' }}>
            <div
                className={styles.sectionContainer}
                style={{
                    width: '100%',
                    position: 'sticky',
                    height: 0,
                    top: 0,
                    left: 0,
                    zIndex: 1,
                }}
            >
                <div style={{ visibility: 'hidden' }} />
                <div style={{ visibility: 'hidden' }} />
                <div>
                    {/* for grid */}
                    <div></div>

                    <div
                        style={{
                            marginLeft: 50,
                            marginTop: 40,
                            display: 'flex',
                            justifyContent: 'space-between',
                            alignItems: 'center',
                        }}
                    >
                        <div style={{ alignSelf: 'end' }}>
                            <div
                                className={'a-cancel-button'}
                                style={{
                                    display: 'inline-block',
                                    width: 150,
                                    marginLeft: 10,
                                    marginBottom: 5,
                                }}
                                onClick={back}
                                data-testid="createPreSaleAccountCancel"
                            >
                                Cancel
                            </div>
                            <AWCButton
                                type={BUTTON_TYPES.PRIMARY}
                                style={{
                                    display: 'inline-block',
                                    width: 150,
                                    marginLeft: 10,
                                }}
                                onClick={saveCustomer}
                                data-testid="createPreSaleAccountSave"
                            >
                                Save & Continue
                            </AWCButton>
                        </div>
                    </div>
                </div>
            </div>
            <div></div>
            <div className={styles.sectionContainer} data-testid="contactInfoSection">
                <div>
                    <div className={styles.sectionHeader}>Contact Info</div>
                    <div className={styles.sectionSubHeader}>* (Required)</div>
                </div>
                <div className={styles.fieldsContainer}>
                    <FastQuoteInput
                        onChange={(value: string) => {
                            setEmailFieldActive(true)
                            setFields((fields) => ({ ...fields, email: value }))
                            emailRef.current = value
                        }}
                        title={'Contact Email'}
                        autoFocus
                        onFocus={(e: any) => {
                            e.currentTarget.setSelectionRange(
                                e.currentTarget.value.length,
                                e.currentTarget.value.length
                            )
                        }}
                        value={fields.email}
                        placeholder={'example@ab.com'}
                        // validationText={failedToAdd && !fields.email && 'Required'}
                        maxLength={50}
                        required
                        validationText={
                            `${failedToAdd && !fields.email ? 'Required' : ''}` +
                            `${
                                fields.email && !validEmail(fields.email) && !emailFieldActive
                                    ? ' Invalid Email'
                                    : ''
                            }`
                        }
                        onBlur={handleEmailBlur}
                        testid="contactInfoContactEmail"
                    />
                    <div className={styles.splitField}>
                        <FastQuoteInput
                            onChange={(value: string) =>
                                setFields((fields) => ({ ...fields, firstName: value }))
                            }
                            title={'First Name'}
                            maxLength={17}
                            disabled={usingLoadedContact && loadedContact?.FirstName?.trim()}
                            value={fields.firstName}
                            validationText={failedToAdd && !fields.firstName && 'Required'}
                            required
                            testid="contactInfoFirstName"
                        />
                        <FastQuoteInput
                            onChange={(value: string) =>
                                setFields((fields) => ({ ...fields, lastName: value }))
                            }
                            title={'Last Name'}
                            disabled={usingLoadedContact && loadedContact?.LastName?.trim()}
                            maxLength={17}
                            value={fields.lastName}
                            required
                            validationText={failedToAdd && !fields.lastName && 'Required'}
                            testid="contactInfoLastName"
                        />
                    </div>
                    <FastQuoteInput
                        onChange={(value: string) =>
                            setFields((fields) => ({
                                ...fields,
                                companyName: value,
                            }))
                        }
                        title={'Company Name'}
                        maxLength={35}
                        value={fields.companyName}
                        required
                        validationText={failedToAdd && !fields.companyName && 'Required'}
                        testid="contactInfoCompanyName"
                    />
                    <FastQuoteInput
                        onChange={(value: string) => {
                            setFields((fields) => ({
                                ...fields,
                                accountCode: value.toUpperCase(),
                            }))
                            debouncedCheckIfExists(value.toUpperCase())
                        }}
                        title={'Account Code'}
                        maxLength={10}
                        value={fields.accountCode}
                        required
                        validationText={
                            customerAlreadyExists.exists &&
                            customerAlreadyExists.search === fields.accountCode
                                ? 'Customer Already Exists'
                                : failedToAdd && !fields.accountCode && 'Required'
                        }
                        testid="contactInfoAccountCode"
                    />
                    <FastQuoteInput
                        onChange={(value: string) =>
                            setFields((fields) => ({ ...fields, title: value }))
                        }
                        maxLength={35}
                        value={fields.title}
                        title={'Job Title'}
                        testid="contactInfoJobTitle"
                    />

                    <div
                        style={{
                            display: 'grid',
                            gap: 20,
                            gridTemplateColumns: '1fr 180px',
                        }}
                    >
                        <InternationalPhoneInput
                            onChange={(value: string) => {
                                setPhoneFieldActive(true)
                                const re = /^[0-9\b]+$/

                                if (value === '' || re.test(value)) {
                                    setFields((fields) => ({ ...fields, phone: value }))
                                }
                            }}
                            value={fields.phone}
                            disabled={usingLoadedContact && loadedContact?.TelephoneNumber?.trim()}
                            placeholder={'(___)___-____'}
                            title={'Phone Number'}
                            onBlur={handlePhoneNumberBlur}
                            validationText={`${
                                !phoneFieldActive &&
                                fields.phone &&
                                !validPhone(fields.phone) &&
                                fields.phone !== '1'
                                    ? ' Invalid Phone'
                                    : ''
                            }`}
                            testid="contactInfoPhoneNumber"
                        />

                        <FastQuoteInput
                            value={phoneExtension}
                            disabled={usingLoadedContact}
                            title={'Ext.'}
                            onChange={(value: string) => {
                                const re = /^[0-9\b]+$/

                                if (value === '' || re.test(value)) {
                                    SetPhoneExtension(value)
                                }
                            }}
                            maxLength={4}
                        />
                        {/* )} */}
                    </div>

                    <div
                        style={{
                            display: 'grid',
                            gap: 20,
                            gridTemplateColumns: '1fr 180px',
                        }}
                    >
                        <AutocompleteAddressInput
                            testid="contactInfoContactAddress"
                            address={fields.contactAddress.address1}
                            disabled={usingLoadedContact && loadedContact?.Address1?.trim()}
                            setAddress={(value: string) =>
                                setFields((fields) => ({
                                    ...fields,
                                    contactAddress: { ...fields.contactAddress, address1: value },
                                }))
                            }
                            setZipcode={(value: string) =>
                                setFields((fields) => ({
                                    ...fields,
                                    contactAddress: { ...fields.contactAddress, zipcode: value },
                                }))
                            }
                            setCity={(value: string) =>
                                setFields((fields) => ({
                                    ...fields,
                                    contactAddress: { ...fields.contactAddress, city: value },
                                }))
                            }
                            setState={(value: string) =>
                                setFields((fields) => ({
                                    ...fields,
                                    contactAddress: { ...fields.contactAddress, state: value },
                                }))
                            }
                            setCountry={(value: string) =>
                                setFields((fields) => ({
                                    ...fields,
                                    contactAddress: { ...fields.contactAddress, country: value },
                                }))
                            }
                            title={'Contact Address'}
                            placeholder={''}
                        />
                        {!hasContactAddress2 ? (
                            <span
                                className={styles.streetAddressButton}
                                onClick={() => setHasContactAddress2(true)}
                            >
                                <span className={styles.plusButton} />
                                <div data-testid="contactInfoAddStreetAddress2">
                                    Add Street Address 2
                                </div>
                            </span>
                        ) : (
                            <span
                                className={styles.streetAddressButton}
                                onClick={() => {
                                    setHasContactAddress2(false)
                                    setFields((fields) => ({
                                        ...fields,
                                        contactAddress: { ...fields.contactAddress, address2: '' },
                                    }))
                                }}
                            >
                                <div data-testid="contactInfoRemoveStreetAddress2">
                                    Remove Street Address 2
                                </div>
                            </span>
                        )}
                    </div>
                    {hasContactAddress2 && (
                        <FastQuoteInput
                            value={fields.contactAddress.address2}
                            onChange={(value: any) =>
                                setFields((fields: any) => ({
                                    ...fields,
                                    contactAddress: {
                                        ...fields.contactAddress,
                                        address2: value,
                                    },
                                }))
                            }
                            disabled={usingLoadedContact && loadedContact?.Address2?.trim()}
                            // gridColumn={4}
                            maxLength={35}
                            title={'Street Address 2'}
                            testid="contactInfoStreetAddress2"
                        />
                    )}
                    <div
                        style={{
                            display: 'grid',
                            gridTemplateColumns: '1fr 150px 150px 100px',
                            gap: 10,
                        }}
                    >
                        <CountryDropdownList
                            title={'Country'}
                            value={fields.contactAddress.country}
                            onChange={(e: any) => {
                                setFields((fields: any) => ({
                                    ...fields,
                                    contactAddress: {
                                        ...fields.contactAddress,
                                        country: e.target.value,
                                        state: '',
                                    },
                                }))
                            }}
                            disabled={usingLoadedContact && loadedContact?.Country?.trim()}
                            testid="contactInfoCountry"
                        />
                        <FastQuoteInput
                            title={'City'}
                            maxLength={35}
                            value={fields.contactAddress.city}
                            disabled={usingLoadedContact && loadedContact?.City?.trim()}
                            onChange={(value: string) =>
                                setFields((fields: any) => ({
                                    ...fields,
                                    contactAddress: {
                                        ...fields.contactAddress,
                                        city: value,
                                    },
                                }))
                            }
                            testid="contactInfoCity"
                        />
                        {fields.contactAddress.country === 'US' ? (
                            <StateDropdownList
                                title={'State'}
                                disabled={usingLoadedContact && loadedContact?.State?.trim()}
                                value={fields.contactAddress.state}
                                onChange={(e: any) =>
                                    setFields((fields: any) => ({
                                        ...fields,
                                        contactAddress: {
                                            ...fields.contactAddress,
                                            state: e.target.value,
                                        },
                                    }))
                                }
                                testid="contactInfoState"
                            />
                        ) : (
                            <FastQuoteInput
                                value={fields.contactAddress.state}
                                onChange={(value: string) =>
                                    setFields((fields: any) => ({
                                        ...fields,
                                        contactAddress: {
                                            ...fields.contactAddress,
                                            state: value,
                                        },
                                    }))
                                }
                                maxLength={5}
                                disabled={usingLoadedContact && loadedContact?.State?.trim()}
                                title={'State'}
                                testid="contactInfoState"
                            />
                        )}
                        {fields.contactAddress.country === 'US' ? (
                            <FastQuoteInput
                                title={'Zip'}
                                value={fields.contactAddress.zipcode}
                                onBlur={handleContactZipBlur}
                                onChange={(value: string) => {
                                    setContactZipFieldActive(true)

                                    setFields((fields: any) => ({
                                        ...fields,
                                        contactAddress: {
                                            ...fields.contactAddress,
                                            zipcode: value,
                                        },
                                    }))
                                }}
                                disabled={usingLoadedContact && loadedContact?.Zipcode?.trim()}
                                maxLength={5}
                                validationText={`${
                                    !contactZipFieldActive &&
                                    fields.contactAddress.zipcode &&
                                    !validUSZip(fields.contactAddress.zipcode)
                                        ? ' Invalid Zip'
                                        : ''
                                }`}
                                testid="contactInfoZip"
                            />
                        ) : (
                            <FastQuoteInput
                                title={'Zip'}
                                value={fields.contactAddress.zipcode}
                                onChange={(value: string) =>
                                    setFields((fields: any) => ({
                                        ...fields,
                                        contactAddress: {
                                            ...fields.contactAddress,
                                            zipcode: value,
                                        },
                                    }))
                                }
                                disabled={usingLoadedContact && loadedContact?.Zipcode?.trim()}
                                maxLength={10}
                                testid="contactInfoZip"
                            />
                        )}
                    </div>
                    <DropdownList
                        variant="outlined"
                        MenuProps={{
                            MenuListProps: { classes: { root: styles.list } },
                        }}
                        displayEmpty
                        style={{ width: '100%' }}
                        value={fields.type}
                        title={'Customer Type'}
                        onChange={(e: any) =>
                            setFields((fields) => ({
                                ...fields,
                                type: e.target.value as string,
                            }))
                        }
                        validationText={
                            fields.type === CUSTOMER_TYPES.UNCERTAIN.typeId.toString()
                                ? 'Customer Type is uncertain.  Update customer type to improve pricing accuracy.  Default CPA will be reseller.'
                                : ''
                        }
                    >
                        {Object.entries(CUSTOMER_TYPES).map((keyValue) => {
                            let value = keyValue[1]
                            return (
                                <MenuItem key={value.typeId} value={value.typeId.toString()}>
                                    {value.typeText}
                                </MenuItem>
                            )
                        })}
                    </DropdownList>
                </div>
            </div>

            <div className={'a-divider'} style={{ marginTop: 40 }} />
            <div style={{ position: 'relative' }}>
                <div className={styles.sectionContainer} style={{ marginBottom: 50 }}>
                    <div>
                        <div className={styles.sectionHeader}>Additional</div>
                        <div className={styles.sectionHeader}>Customer Info</div>
                        <div className={styles.sectionSubHeader}>(Optional)</div>
                    </div>
                    <div style={{ position: 'relative' }}>
                        <div className={styles.fieldsContainer} style={{ height: 'fit-content' }}>
                            <FastQuoteInput
                                title={() => (
                                    <div
                                        style={{
                                            marginBottom: '0.3em',
                                            display: 'flex',
                                            alignItems: 'flex-end',
                                        }}
                                    >
                                        <span
                                            style={{
                                                fontSize: '0.9em',
                                            }}
                                        >
                                            Bill To Company Name
                                        </span>
                                        <span
                                            style={{
                                                // marginBottom: 30,
                                                marginLeft: 10,
                                                height: 24,
                                                lineHeight: 0.8,
                                                fontSize: 14,
                                                display: 'inline-block',
                                                width: 164,
                                            }}
                                            className={'a-cancel-button'}
                                            onClick={copyContactToBillTo}
                                            data-testid="additionalInfoCopyContactAddressBillTo"
                                        >
                                            Copy contact address
                                        </span>
                                    </div>
                                )}
                                maxLength={35}
                                value={fields.billToAddress.name}
                                onChange={(value: string) =>
                                    setFields((fields: any) => ({
                                        ...fields,
                                        billToAddress: {
                                            ...fields.billToAddress,
                                            name: value,
                                        },
                                    }))
                                }
                            />

                            <div
                                style={{
                                    display: 'grid',
                                    gap: 20,
                                    gridTemplateColumns: '1fr 180px',
                                }}
                            >
                                <AutocompleteAddressInput
                                    testid="additionalInfoBillToAddress"
                                    address={fields.billToAddress.address1}
                                    setAddress={(value: string) =>
                                        setFields((fields) => ({
                                            ...fields,
                                            billToAddress: {
                                                ...fields.billToAddress,
                                                address1: value,
                                            },
                                        }))
                                    }
                                    setZipcode={(value: string) =>
                                        setFields((fields) => ({
                                            ...fields,
                                            billToAddress: {
                                                ...fields.billToAddress,
                                                zipcode: value,
                                            },
                                        }))
                                    }
                                    setCity={(value: string) =>
                                        setFields((fields) => ({
                                            ...fields,
                                            billToAddress: {
                                                ...fields.billToAddress,
                                                city: value,
                                            },
                                        }))
                                    }
                                    setState={(value: string) =>
                                        setFields((fields) => ({
                                            ...fields,
                                            billToAddress: {
                                                ...fields.billToAddress,
                                                state: value,
                                            },
                                        }))
                                    }
                                    setCountry={(value: string) =>
                                        setFields((fields) => ({
                                            ...fields,
                                            billToAddress: {
                                                ...fields.billToAddress,
                                                country: value,
                                            },
                                        }))
                                    }
                                    title={'Bill To Address'}
                                    placeholder={''}
                                />
                                {!hasBillToAddress2 ? (
                                    <span
                                        className={styles.streetAddressButton}
                                        onClick={() => setHasBillToAddress2(true)}
                                    >
                                        <span className={styles.plusButton} />
                                        <div data-testid="additionalInfoBillToAddStreetAddress2">
                                            Add Street Address 2
                                        </div>
                                    </span>
                                ) : (
                                    <span
                                        className={styles.streetAddressButton}
                                        onClick={() => {
                                            setHasBillToAddress2(false)
                                            setFields((fields) => ({
                                                ...fields,
                                                billToAddress: {
                                                    ...fields.billToAddress,
                                                    address2: '',
                                                },
                                            }))
                                        }}
                                    >
                                        <div data-testid="additionalInfoBillToRemoveStreetAddress2">
                                            Remove Street Address 2
                                        </div>
                                    </span>
                                )}
                            </div>
                            {hasBillToAddress2 && (
                                <FastQuoteInput
                                    value={fields.billToAddress.address2}
                                    onChange={(value: any) =>
                                        setFields((fields: any) => ({
                                            ...fields,
                                            billToAddress: {
                                                ...fields.billToAddress,
                                                address2: value,
                                            },
                                        }))
                                    }
                                    // gridColumn={4}
                                    title={'Street Address 2'}
                                    maxLength={35}
                                    testid="additionalInfoBillToStreetAddress2"
                                />
                            )}
                            <div
                                style={{
                                    display: 'grid',
                                    gridTemplateColumns: '1fr 150px 150px 100px',
                                    gap: 10,
                                }}
                            >
                                <CountryDropdownList
                                    title={'Country'}
                                    value={fields.billToAddress.country}
                                    onChange={(e: any) =>
                                        setFields((fields: any) => ({
                                            ...fields,
                                            billToAddress: {
                                                ...fields.billToAddress,
                                                country: e.target.value,
                                                state: '',
                                            },
                                        }))
                                    }
                                    testid="additionalInfoBillToCountry"
                                />
                                <FastQuoteInput
                                    title={'City'}
                                    maxLength={35}
                                    value={fields.billToAddress.city}
                                    onChange={(value: string) =>
                                        setFields((fields: any) => ({
                                            ...fields,
                                            billToAddress: {
                                                ...fields.billToAddress,
                                                city: value,
                                            },
                                        }))
                                    }
                                    testid="additionalInfoBillToCity"
                                />
                                {fields.billToAddress.country === 'US' ? (
                                    <StateDropdownList
                                        title={'State'}
                                        value={fields.billToAddress.state}
                                        onChange={(e: any) =>
                                            setFields((fields: any) => ({
                                                ...fields,
                                                billToAddress: {
                                                    ...fields.billToAddress,
                                                    state: e.target.value,
                                                },
                                            }))
                                        }
                                        testid="additionalInfoBillToState"
                                    />
                                ) : (
                                    <FastQuoteInput
                                        maxLength={5}
                                        value={fields.billToAddress.state}
                                        onChange={(value: any) =>
                                            setFields((fields: any) => ({
                                                ...fields,
                                                billToAddress: {
                                                    ...fields.billToAddress,
                                                    state: value,
                                                },
                                            }))
                                        }
                                        title={'State'}
                                        testid="additionalInfoBillToState"
                                    />
                                )}
                                {fields.billToAddress.country === 'US' ? (
                                    <FastQuoteInput
                                        title={'Zip'}
                                        maxLength={5}
                                        value={fields.billToAddress.zipcode}
                                        onBlur={handleBillToZipBlur}
                                        onChange={(value: string) => {
                                            setBillToZipFieldActive(true)

                                            setFields((fields: any) => ({
                                                ...fields,
                                                billToAddress: {
                                                    ...fields.billToAddress,
                                                    zipcode: value,
                                                },
                                            }))
                                        }}
                                        validationText={`${
                                            !billToZipFieldActive &&
                                            fields.billToAddress.zipcode &&
                                            !validUSZip(fields.billToAddress.zipcode)
                                                ? ' Invalid Zip'
                                                : ''
                                        }`}
                                        testid="additionalInfoBillToZip"
                                    />
                                ) : (
                                    <FastQuoteInput
                                        title={'Zip'}
                                        maxLength={10}
                                        value={fields.billToAddress.zipcode}
                                        onChange={(value: string) =>
                                            setFields((fields: any) => ({
                                                ...fields,
                                                billToAddress: {
                                                    ...fields.billToAddress,
                                                    zipcode: value,
                                                },
                                            }))
                                        }
                                        testid="additionalInfoBillToZip"
                                    />
                                )}
                            </div>

                            <FastQuoteInput
                                title={() => (
                                    <div
                                        style={{
                                            marginBottom: '0.3em',
                                            display: 'flex',
                                            alignItems: 'flex-end',
                                        }}
                                    >
                                        <span
                                            style={{
                                                fontSize: '0.9em',
                                            }}
                                        >
                                            Ship To Company Name
                                        </span>
                                        <span
                                            style={{
                                                // marginBottom: 30,
                                                marginLeft: 10,
                                                height: 24,
                                                lineHeight: 0.8,
                                                fontSize: 14,
                                                display: 'inline-block',
                                                width: 164,
                                            }}
                                            className={'a-cancel-button'}
                                            onClick={copyContactToShipTo}
                                            data-testid="additionalInfoCopyContactAddressShipTo"
                                        >
                                            Copy contact address
                                        </span>
                                    </div>
                                )}
                                maxLength={35}
                                value={fields.shipToAddress.name}
                                onChange={(value: string) =>
                                    setFields((fields: any) => ({
                                        ...fields,
                                        shipToAddress: {
                                            ...fields.shipToAddress,
                                            name: value,
                                        },
                                    }))
                                }
                            />

                            <div
                                style={{
                                    display: 'grid',
                                    gap: 20,
                                    gridTemplateColumns: '1fr 180px',
                                }}
                            >
                                <AutocompleteAddressInput
                                    testid="additionalInfoShipToAddress"
                                    address={fields.shipToAddress.address1}
                                    setAddress={(value: string) =>
                                        setFields((fields) => ({
                                            ...fields,
                                            shipToAddress: {
                                                ...fields.shipToAddress,
                                                address1: value,
                                            },
                                        }))
                                    }
                                    setZipcode={(value: string) =>
                                        setFields((fields) => ({
                                            ...fields,
                                            shipToAddress: {
                                                ...fields.shipToAddress,
                                                zipcode: value,
                                            },
                                        }))
                                    }
                                    setCity={(value: string) =>
                                        setFields((fields) => ({
                                            ...fields,
                                            shipToAddress: {
                                                ...fields.shipToAddress,
                                                city: value,
                                            },
                                        }))
                                    }
                                    setState={(value: string) =>
                                        setFields((fields) => ({
                                            ...fields,
                                            shipToAddress: {
                                                ...fields.shipToAddress,
                                                state: value,
                                            },
                                        }))
                                    }
                                    setCountry={(value: string) =>
                                        setFields((fields) => ({
                                            ...fields,
                                            shipToAddress: {
                                                ...fields.shipToAddress,
                                                country: value,
                                            },
                                        }))
                                    }
                                    title={'Ship To Address'}
                                    placeholder={''}
                                />
                                {!hasShipToAddress2 ? (
                                    <span
                                        className={styles.streetAddressButton}
                                        onClick={() => setHasShipToAddress2(true)}
                                    >
                                        <span className={styles.plusButton} />
                                        <div data-testid="additionalInfoShipToAddStreetAddress2">
                                            Add Street Address 2
                                        </div>
                                    </span>
                                ) : (
                                    <span
                                        className={styles.streetAddressButton}
                                        onClick={() => {
                                            setHasShipToAddress2(false)
                                            setFields((fields) => ({
                                                ...fields,
                                                shipToAddress: {
                                                    ...fields.shipToAddress,
                                                    address2: '',
                                                },
                                            }))
                                        }}
                                    >
                                        <div data-testid="additionalInfoShipToRemoveStreetAddress2">
                                            Remove Street Address 2
                                        </div>
                                    </span>
                                )}
                            </div>
                            {hasShipToAddress2 && (
                                <FastQuoteInput
                                    value={fields.shipToAddress.address2}
                                    onChange={(value: any) =>
                                        setFields((fields: any) => ({
                                            ...fields,
                                            shipToAddress: {
                                                ...fields.shipToAddress,
                                                address2: value,
                                            },
                                        }))
                                    }
                                    // gridColumn={4}
                                    title={'Street Address 2'}
                                    maxLength={35}
                                    testid="additionalInfoShipToStreetAddress2"
                                />
                            )}
                            <div
                                style={{
                                    display: 'grid',
                                    gridTemplateColumns: '1fr 150px 150px 100px',
                                    gap: 10,
                                }}
                            >
                                <CountryDropdownList
                                    title={'Country'}
                                    value={fields.shipToAddress.country}
                                    onChange={(e: any) =>
                                        setFields((fields: any) => ({
                                            ...fields,
                                            shipToAddress: {
                                                ...fields.shipToAddress,
                                                country: e.target.value,
                                                state: '',
                                            },
                                        }))
                                    }
                                    testid="additionalInfoShipToCountry"
                                />
                                <FastQuoteInput
                                    title={'City'}
                                    maxLength={35}
                                    value={fields.shipToAddress.city}
                                    onChange={(value: string) =>
                                        setFields((fields: any) => ({
                                            ...fields,
                                            shipToAddress: {
                                                ...fields.shipToAddress,
                                                city: value,
                                            },
                                        }))
                                    }
                                    testid="additionalInfoShipToCity"
                                />
                                {fields.shipToAddress.country === 'US' ? (
                                    <StateDropdownList
                                        title={'State'}
                                        value={fields.shipToAddress.state}
                                        onChange={(e: any) =>
                                            setFields((fields: any) => ({
                                                ...fields,
                                                shipToAddress: {
                                                    ...fields.shipToAddress,
                                                    state: e.target.value,
                                                },
                                            }))
                                        }
                                        testid="additionalInfoShipToState"
                                    />
                                ) : (
                                    <FastQuoteInput
                                        maxLength={5}
                                        value={fields.shipToAddress.state}
                                        onChange={(value: any) =>
                                            setFields((fields: any) => ({
                                                ...fields,
                                                shipToAddress: {
                                                    ...fields.shipToAddress,
                                                    state: value,
                                                },
                                            }))
                                        }
                                        title={'State'}
                                        testid="additionalInfoShipToState"
                                    />
                                )}
                                {fields.shipToAddress.country === 'US' ? (
                                    <FastQuoteInput
                                        title={'Zip'}
                                        maxLength={5}
                                        value={fields.shipToAddress.zipcode}
                                        onBlur={handleShipToZipBlur}
                                        onChange={(value: string) => {
                                            setShipToZipFieldActive(true)

                                            setFields((fields: any) => ({
                                                ...fields,
                                                shipToAddress: {
                                                    ...fields.shipToAddress,
                                                    zipcode: value,
                                                },
                                            }))
                                        }}
                                        validationText={`${
                                            !shipToZipFieldActive &&
                                            fields.shipToAddress.zipcode &&
                                            !validUSZip(fields.shipToAddress.zipcode)
                                                ? ' Invalid Zip'
                                                : ''
                                        }`}
                                        testid="additionalInfoShipToZip"
                                    />
                                ) : (
                                    <FastQuoteInput
                                        title={'Zip'}
                                        maxLength={10}
                                        value={fields.shipToAddress.zipcode}
                                        onChange={(value: string) =>
                                            setFields((fields: any) => ({
                                                ...fields,
                                                shipToAddress: {
                                                    ...fields.shipToAddress,
                                                    zipcode: value,
                                                },
                                            }))
                                        }
                                        testid="additionalInfoShipToZip"
                                    />
                                )}
                            </div>

                            {/* 
                            <div>
                                <DropdownList
                                    variant="outlined"
                                    MenuProps={{
                                        MenuListProps: { classes: { root: styles.list } },
                                    }}
                                    title={'Identifier'}
                                    displayEmpty
                                    style={{ width: '100%' }}
                                    value={fields.identifier}
                                    onChange={(e: any) =>
                                        setFields((fields) => ({
                                            ...fields,
                                            identifier: e.target.value as string,
                                            projectName: '',
                                        }))
                                    }
                                >
                                    {Object.entries(CUSTOMER_REASONS).map((keyValue) => {
                                        let value = keyValue[1]
                                        return (
                                            <MenuItem value={value.reasonId.toString()}>
                                                {value.reasonName}
                                            </MenuItem>
                                        )
                                    })}
                                </DropdownList>
                                {fields.identifier ===
                                    CUSTOMER_REASONS.OTHER.reasonId.toString() && (
                                    <>
                                        <div style={{ marginTop: 28 }}></div>

                                        <FastQuoteInput
                                            onChange={(newValue: string) =>
                                                setFields((fields) => ({
                                                    ...fields,
                                                    projectName: newValue,
                                                }))
                                            }
                                            title={'Qualifier'}
                                            value={fields.projectName}
                                            maxLength={50}
                                        />
                                    </>
                                )}
                                <div style={{ marginBottom: 10, marginTop: 10 }}>
                                    Select Pricing Tier
                                </div>
                                <PricingTiersTable
                                    selectedTier={selectedTier}
                                    setSelectedTier={setSelectedTier}
                                />
                            </div> */}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}
export default CreatePreSaleAccount
